import { render } from "./index.vue?vue&type=template&id=6009b989&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=6009b989&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=6009b989&lang=css"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/beautifuldai-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6009b989"]])

export default __exports__